import { AppBar, Box } from '@mui/material';

import { AccountMenu } from 'features/AccountMenu';
import { Notifications } from 'features/Notifications';
import reopsLogo from 'shared/assets/svg/re-ops-logo-filled.svg';
import { headerHeightStyle } from 'shared/const/styles';

export const Header = () => {
    return (
        <>
            <Box height={headerHeightStyle} />
            <AppBar
                sx={{
                    boxShadow: 'none',
                    bgcolor: 'common.white',
                    zIndex: 1201,
                }}
            >
                <Box
                    height={headerHeightStyle}
                    display={'flex'}
                    justifyContent={'space-between'}
                    pr="40px"
                    pl="24px"
                >
                    <img
                        width="120"
                        height="64"
                        src={String(reopsLogo)}
                        alt="Re-ops"
                    />
                    <Box display="flex" alignItems="center" gap="24px">
                        <Notifications />
                        <AccountMenu />
                    </Box>
                </Box>
            </AppBar>
        </>
    );
};
